<template>
    <div id="finance">
        <div style="margin:30px 0 10px" align="left">
            <el-row :gutter="10">
                <el-col align="left" :span="16">
                    <el-button type="primary" style="visibility:hidden"></el-button>
                </el-col>
                <el-col align="center" :span="7">
                    <el-input v-model="hospName" size="small" placeholder="医院名称" clearable @keyup.enter.native="query()"></el-input>
                </el-col>
                    <el-col align="center" :span="1">
                    <el-button icon="el-icon-search" size="small" circle @click="query()"></el-button>
                </el-col>
            </el-row>
        </div>
        <div>
            <template class="table">
                <el-table :data="hospList" ref="hospList"  style="width: 100%" @current-change="selectionChange">
                    <el-table-column type="index" align="center" label="序号" > </el-table-column>
                    <el-table-column prop="hospVo.hospName" align="center" label="医院名称" > </el-table-column>
                    <el-table-column prop="hospVo.hospCode" align="center" label="医院编号" > </el-table-column>
                    <el-table-column prop="hospVo.hospAdminName" align="center" label="联系人" > </el-table-column>
                    <el-table-column prop="hospVo.hospAdminTel" align="center" label="电话"></el-table-column>
                    <el-table-column prop="hospVo.hospRank" align="center" label="等级"></el-table-column>
                    <el-table-column prop="hospVo.hospAddr" align="center" label="地址" width="260"></el-table-column>
                    <el-table-column prop="saName" align="center" label="管理员" width="260"></el-table-column>
                </el-table>
            </template>
        </div>
        <div class="page">
            <el-pagination  :page-size="15" :page-count="5" layout="total, prev, pager, next" :total="tablePage" @current-change='changePage' style="text-align:right"></el-pagination>
        </div>

    </div>
</template>

<script>
import hospImg from '@/assets/hospital.jpg'

export default {
    name:'finance',
    data(){
        return{
            userInfo:'',
            tablePage : 15,
            hospList:[],
            //查询医院名称
            hospName:'',
            page:1,
        }
    },
    mounted(){
        this.getHospList();
    },
    methods:{
        //获取医院列表
        getHospList(){
            var obj={
                page:this.page,
                rows:15,
                hospName:this.hospName
            }
            this.$ajax.post(this.$domain.listHospInfo,obj)
            .then(ret=>{
                var res=ret.data;
                console.log(res);
                if(res.code=="10"){
                    this.hospList=res.data.list;
                    this.tablePage=res.data.count;
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
                else{
                    console.log(res)
                }
            })

        },
        // 选择医院
        selectionChange(row){
            this.$common.setStorage('hospMsg',row);
            this.$router.push({path:'financeDetail'})
        },
        // 分页(OK)
        changePage(val){
            this.page=val
            this.getHospList()
        },
        // 取消,清空表单 隐藏dialog
        cancel(){
            this.addForm = {
                hospName:'',
                hospAddr:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
                hospRegionCode:'',
                hospAddArr:[]
            };
            this.addDialog = false;
            this.$refs['addForm'].resetFields();
        },
        //条件查询医院(OK)
        query(){
            this.page=1
            this.getHospList()
        }
    }
}
</script>

<style>
    .hospImg{
        width:120px;
        height:120px;
        border-radius: 50%;
    }
    #finance{
        width:100%;
        min-width: 1200px;
        padding:0 10%;
        box-sizing: border-box;
    }
    #finance .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    .el-table{
        cursor: pointer;
    }
    .el-table .selected-row{
        background:#cee3e9;
    }
    #finance .el-cascader{
        width:100%;
    }
    .hospPic{
        height:100px;
        margin-right:20px;
    }
    .el-form-item__content{
        margin-left:0 !important;
        display: flex;
        justify-content: flex-start
    }
    .adminInfo{
        width:80%;
        height:32px;
        border-bottom:1px solid #ccc;
        text-align: left;
        padding-left:2px
    }
    .radioGroup{
        text-align: left;
        margin-top:12px;
        width:100%;
    }
</style>



// WEBPACK FOOTER //
// src/page/finance.vue